import ManageVM from './manage-vm';
export default {
  prepUI: function() {
    console.log('Kadenze.ForumManageListing prepUI function called');
    $('.forum-list-preview').not(':eq(0)').remove();
  },
  init: function(node) {
    var forum_data = JSON.parse(node.dataset.forumsData);
    var validationOpts = _.extend({}, Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS, {insertMessages: false});
    ko.applyBindingsWithValidation(new ManageVM(forum_data), node, validationOpts);
  }
};
